import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import styles from './direction-button.module.css'
import { useMessages2 } from '../../hooks/useLanguage';

type ButtonType = 'next' | 'prev' | 'invert';

const DirectionButton = ({ className, type, onClick, text }: {
    type: ButtonType
    className?: string
    children?: React.ReactNode
    text?: string
    onClick: () => void;
}) => {

    const {messages} = useMessages2();
    
    return (
        <>
            { type === 'prev' && 
                <button className={`${styles.directionButton} ${styles.prev} ${className}`} onClick={onClick}>
                        <FontAwesomeIcon icon={faChevronLeft} style={{color: "#d03d32"}} /> 
                        <span>{ text ?? messages?.page_prev_button }</span>
                </button>
            }
            { type === "next" && 
                <button className={`${styles.directionButton} ${styles.next} ${className}`} onClick={onClick}>

                        <span>{ text ?? messages?.page_next_button }</span>
                        <FontAwesomeIcon icon={faChevronRight} style={{color: "#d03d32"}} /> 
                </button>
            }
            { type === "invert" && 
                <button className={`${styles.directionButton} ${styles.invert} ${className}`} onClick={onClick}>
                        <FontAwesomeIcon icon={faChevronRight} style={{color: "#d03d32"}} /> 
                        <span>{ text }</span>
                </button>
            }
        </>
)}
export default DirectionButton;
